import React from 'react';
import { FC } from 'react';

export const Scheme: FC = () => {
    return (
        <div>
            <div> 
                <iframe title="Slide" src="https://docs.google.com/presentation/d/e/2PACX-1vTYb3ORUhzSiNWqoVewL7CNJkt1p1JfkPQwd_-QuNWXkDsEJDoU7kF6WJlZV_M_9_JLPy2LtJgtEAil/embed?start=false&loop=false&delayms=3000"
                 width="1200" height="675"></iframe>
            </div>
            <form>
                <label>Notes</label>
                <textarea>
                </textarea>
            </form>
        </div>
    )
};